import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import Link from 'components/link';
import Heading from 'components/heading';

const themes = {
  regular: 'regular',
  button: 'button'
};

const colors = {
  green: 'green',
  yellow: 'yellow',
  red: 'red'
};

const alignments = {
  left: 'left',
  right: 'right'
};

const CallToAction = ({ buttons, text, alignment, theme, color }) => {
  const multiple = (buttons || []).length > 1;
  const ListOrDiv = buttons?.length > 1 ? 'ul' : 'div';
  const ListItemOrDiv = buttons?.length > 1 ? 'li' : 'div';

  return (
    <div
      className={cn('call-to-action', {
        'call-to-action--multiple': multiple,
        [`call-to-action--${alignment}`]: !multiple
      })}
    >
      <div className="call-to-action__content">
        {text && (
          <div className="call-to-action__heading-wrapper">
            <Heading level={2} className="call-to-action__heading">
              {text}
            </Heading>
          </div>
        )}
        {!!buttons?.length && (
          <ListOrDiv
            className={cn(
              'call-to-action__buttons',
              `call-to-action__buttons--${buttons.length}`
            )}
          >
            {buttons.map(btn => (
              <ListItemOrDiv
                key={'cta' + btn?.text}
                className="call-to-action__button-item"
              >
                {theme === themes.regular ? (
                  <div className="call-to-action__link--regular">
                    <Link
                      {...btn}
                      animation="expand"
                      color={Link.colors.black}
                      fontTheme={Link.fontThemes.uppercaseCondensed}
                      showIcon
                    />
                  </div>
                ) : (
                  <div
                    className={cn(
                      'call-to-action__link',
                      `call-to-action__link--${theme ? theme : themes.button}`
                    )}
                  >
                    <Link
                      animation="expand"
                      text={btn.text}
                      url={btn.url}
                      theme={Link.themes.buttonSmall}
                      shouldOpenInNewTab={btn.shouldOpenInNewTab}
                      className={cn({
                        [`call-to-action__link--${color}`]: color
                      })}
                    />
                  </div>
                )}
              </ListItemOrDiv>
            ))}
          </ListOrDiv>
        )}
      </div>
    </div>
  );
};

CallToAction.defaultProps = {
  buttons: [],
  alignment: alignments.left,
  theme: themes.button,
  color: colors.green,
  shouldOpenInNewTab: false
};

CallToAction.propTypes = {
  text: PropTypes.string,
  alignment: PropTypes.oneOf(Object.values(alignments)),
  theme: PropTypes.oneOf(Object.values(themes)),
  color: PropTypes.oneOf(Object.values(colors)),
  buttons: PropTypes.arrayOf(Link.propTypes)
};

CallToAction.alignments = alignments;

export default CallToAction;
